import { AlertServiceProvider } from './services/alert-service/alert-service';
import { AnalyticsServiceProvider } from './services/analytics-service/analytics-service';
import { ApplicationUpdateServiceProvider } from './services/application-update-service/application-update-service';
import { AppLoadingService } from './services/app-loading-service/app-loading-service';
import { AuthenticationServiceProvider } from './services/authentication-service/authentication-service';
import { CameraService } from './services/camera-service/camera-service';
import { CodePushServiceProvider } from './services/code-push-service/code-push-service';
import { ConfigServiceProvider } from './services/config-service/config-service';
import { DataUpdateServiceProvider } from './services/data-update-service/data-update-service';
import { DisplayServiceProvider } from './services/display-service/display-service';
import { FilterServiceProvider } from './services/filter-service/FilterServiceProvider';
import { GeolocationServiceProvider } from './services/geolocation-service/geolocation-service';
import { GroupServiceProvider } from './services/group-service/group-service';
import { LayoutServiceProvider } from './services/layout-service/layout-service';
import { LifeCycleServiceProvider } from './services/life-cycle-service/life-cycle-service';
import { LocationServiceProvider } from './services/location-service/location-service';
import { NgModule } from '@angular/core';
import { NonWorkingDaysConfigServiceProvider } from './services/non-working-days-config-service/non-working-days-config-service';
import { PlatformService } from './services/platform-service/platform-service';
import { PlayerServiceProvider } from './services/player-service/player-service';
import { PushServiceProvider } from './services/push-service/push-service';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StorageServiceProvider } from './services/storage-service/storage-service';
import { TextServiceProvider } from './services/text-service/text-service';
import { UserGroupsServiceProvider } from './services/user-groups-service/user-groups-service';
import { UsersServiceProvider } from './services/users-service/users-service';
import { WelcomeInAppPageModule } from './pages/welcome-in-app/welcome-in-app.module';
import { TenantService } from './services/tenant-service/tenant.service';

@NgModule({
  providers: [
    ConfigServiceProvider,
    AlertServiceProvider,
    AuthenticationServiceProvider,
    CodePushServiceProvider,
    ConfigServiceProvider,
    DataUpdateServiceProvider,
    DisplayServiceProvider,
    NonWorkingDaysConfigServiceProvider,
    StorageServiceProvider,
    TextServiceProvider,
    PushServiceProvider,
    LayoutServiceProvider,
    LifeCycleServiceProvider,
    AnalyticsServiceProvider,
    LocationServiceProvider,
    GeolocationServiceProvider,
    GroupServiceProvider,
    UserGroupsServiceProvider,
    FilterServiceProvider,
    PlayerServiceProvider,
    UsersServiceProvider,
    ApplicationUpdateServiceProvider,
    AppLoadingService,
    PlatformService,
    CameraService,
    SplashScreen,
    TenantService,
  ],
  imports: [WelcomeInAppPageModule],
})
export class SellionsCoreModule {}



// WEBPACK FOOTER //
// ./src/modules/core/core.module.ts